// extracted by mini-css-extract-plugin
export default {"MenuItem":"_MenuItem--vbZdn","Item":"_Item--mbKM_","Disabled":"_Disabled--zNVxE","MenuItemActive":"_MenuItemActive--V2nqp","Beta":"_Beta--Tl9t5"};